export const DailyMenuTranslationJP = {
  DailyMenu: {
    Title: '日替わりメニュー設定',
    HolidayDesignation: '〇休日指定',
    HolidayContent: '※休日限定が有効の場合、該当曜日が休日だった場合、休日メニューが優先されます',
    DayDesignation: '〇曜日指定',
    Button: {
      save: '保存',
      target_menu: '対象メニュー',
    },
    Table: {
      holiday: '休日',
      enable_disable: '有効／無効',
      target_menu: '対象メニュー',
      holiday_text: '土日祝限定',
      weekdays: '曜日',
    },
    Validator: {
      name: 'Required name field',
      500: '500 error server',
      success: '成功',
      error: '失敗',
      delete_success: '削除しました',
      add_success: '保存しました',
      restore_success: '復元しました。',
    },
    Confirm: {
      Enable_Sat_Sun_Day:
        'こちらの曜日は、「土日祝日限定」が有効なため設定できません。設定が必要な場合は、「土日祝日限定」を無効にしてください。',
      Enable_Holiday:
        '「土日祝日限定」を有効にすると、曜日指定の「土曜日」「日曜日」の設定は無効になります。よろしいですか？',
    },
  },
};
